


















import ErrorMessagesComponent from "@/shared/components/ErrorMessages.vue";
import ResultsOverlayComponent from "./components/ResultsOverlay/ResultsOverlay.vue";
import FormComponent from "./components/Form/Form.vue";
import {
  defineComponent,
  onMounted,
  PropType,
  watch,
} from "@vue/composition-api";
import { useActions, useGetters, useMutations } from "vuex-composition-helpers";
import { IConfig } from "./models/config-viewmodel";

export default defineComponent({
  name: "SearchOverlayWidget",
  components: {
    ErrorMessagesComponent,
    FormComponent,
    ResultsOverlayComponent,
  },
  props: {
    configRaw: { type: Object as PropType<IConfig>, required: true },
  },
  setup: (props) => {
    const {
      searchQuery,
      error,
      externalSearchActive,
      searchActive,
      employeeResults,
      config,
      searchResults,
    } = useGetters([
      "searchResults",
      "employeeResults",
      "searchActive",
      "searchQuery",
      "config",
      "error",
      "externalSearchActive",
    ]);

    const { init, onChange } = useActions(["init", "onChange"]);

    const { setError } = useMutations(["setError"]);

    watch([searchQuery, externalSearchActive], () => {
      onChange();
    });

    watch(externalSearchActive, () => {
      setError("");
    });

    onMounted(async () => {
      await init(props.configRaw);
    });
    return {
      error,
      searchQuery,
      externalSearchActive,
      searchActive,
      searchResults,
      config,
      employeeResults,
    };
  },
});
